module.exports = __webpack_public_path__ + "static/media/mtvscout.19110eab.png";